export default "__VITE_ASSET__Cg$ZsEuy__"